export const PatientsPermissions = {
    List: 2000,
    Create: 2001,
    Update: 2002,
    ShowDetails: 2003,
    Delete: 2004,
    LockUnLock: 2005,

}
export const AppointmentsPermissions = {
    List: 3000,
    Create: 3001,
    Update: 3002,
    ShowDetails: 3003,
    // Delete: 11004,
    ApproveCancel: 3005,
    DirectBooking: 3006,
}
export const PatientsPaymentsPermissions = {
    List: 4000,
    Create: 4001,
    Update: 4002,
    ShowDetails: 4003,
    // Delete: 11004,
    ApproveCancel: 4005,
    Print: 4006,
    Cancel: 4007,


}
export const PatientsProceduresPermissions = {
    List: 5000,
    Create: 5001,
    Update: 5002,
    ShowDetails: 5004,
    Procedures: 5006,

}
export const DoctorsAppointmentsPermissions = {
    List: 6000,
    ShowDetails: 6004,
    ApproveCancel: 6005,
    Review: 6006,
    Procedures: 6007,
    Servies: 6007,

}
export const invoicesPermissions = {
    List: 24000,
    Create: 24001,
    Update: 24002,
    ShowDetails: 24003,
    Delete: 24004,
    ApproveCancel: 24005,
    Print: 24006,
    Cancel: 24007,

}
export const analysisInvoicesPermissions = {
    List: 23000,
    Create: 23001,
    Update: 23002,
    ShowDetails: 23003,
    Delete: 23004,
    Print: 23006,
    Cancel: 23004,

}
export const doctorPrescriptionsPermissions = {
    List: 27000,
    Create: 27001,
    Update: 27002,
    ShowDetails: 27003,
    Delete: 27004,
    Print: 27006,
    Cancel: 27004,



}
export const workDaysClosingPermissions = {
    List: 28000,
    Create: 28001

}